(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiendas"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Obtener el código de país del usuario
  fetch('https://ipapi.co/json/')
    .then(response => response.json())
    .then(data => {
      const userCountry = data.country; // País del usuario (por ejemplo, 'CL' para Chile, 'PE' para Perú)
      
      // Determinar el dominio actual (podrías adaptarlo para verificar otras URLs también)
      const currentDomain = window.location.hostname;

      // Verificar si estamos en la página de Chile o Perú
      if (userCountry === 'CL' && currentDomain.includes('unnostore.com')) {
        // Si el usuario es de Chile pero está en la página de Perú, redirigir a Chile
        showRedirectPopup('Chile', 'https://unnounderwear.cl/');
      } else if (userCountry === 'PE' && currentDomain.includes('unnounderwear.cl')) {
        // Si el usuario es de Perú pero está en la página de Chile, redirigir a Perú
        showRedirectPopup('Perú', 'https://unnostore.com/');
      }
    })
    .catch(error => console.error('Error al obtener la ubicación:', error));

  // Función para mostrar el popup de redirección
  function showRedirectPopup(country, redirectUrl) {
    const popup = document.createElement('div');
    popup.style.position = 'fixed';
    popup.style.bottom = '40px'; // Distancia del borde inferior
    popup.style.right = '40px'; // Distancia del borde derecho
    popup.style.padding = '20px';
    popup.style.backgroundColor = '#0f7ca8';
    popup.style.border = '1px solid #ccc';
    popup.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
    popup.style.zIndex = '1000';
    popup.style.color = '#ffffff'; // Color del texto
    popup.innerHTML = `
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <p style="margin: 0;">¿Estás en ${country}?  Tenemos una tienda en ${country}</p>
        <button id="close-button" style="background: none; border: none; color: #ffffff; font-size: 16px; cursor: pointer;">✖</button>
      </div>
      <button id="redirect-button" style="font-weight: bold; text-decoration: underline; color: #ffffff; background: none; border: none; cursor: pointer;">¡Conócela aquí!</button>
    `;

    document.body.appendChild(popup);

    document.getElementById('redirect-button').onclick = function() {
      window.location.href = redirectUrl; // Redirigir al país correspondiente
    };

    document.getElementById('close-button').onclick = function() {
      popup.style.display = 'none'; // Ocultar el popup
    };
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
